import { useState } from "react";
import { FilePdf, CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const filenameFrom = (header, fallback) => {
  const m = /filename="?([^";]+)"?/i.exec(header || "");
  return m ? m[1] : fallback;
};

export function DownloadFlashPdfButton({ clientId, params, label = "", testid, className = "" }) {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/clients/${clientId}/flash-pdf`, { responseType: "blob", params });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filenameFrom(r.headers["content-disposition"], "Flash-Report.pdf");
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      toast.success("Flash report downloaded");
    } catch (e) {
      console.error("Flash PDF download failed", e);
      toast.error("Couldn't build the PDF — check the Xero connection and try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      size="sm"
      variant="outline"
      onClick={download}
      disabled={busy || params === null}
      data-testid={testid}
      title="Download MTD Flash Report (PDF)"
      className={`rounded-md border-[#E2E8F0] text-xs ${className}`}
    >
      {busy ? <CircleNotch size={13} className="animate-spin" /> : <FilePdf size={13} />}
      {label && <span className="ml-1.5">{busy ? "Building…" : label}</span>}
    </Button>
  );
}
